(function () {
  function initHomeTopSelectorSection(root) {
    // root = document oder frisch geladene Section
    const sections = (root || document).querySelectorAll('.home-top-selector-section');

    sections.forEach((section) => {
      // Doppel-Initialisierung verhindern
      if (section.dataset.selectorInitialized === 'true') return;
      section.dataset.selectorInitialized = 'true';

      const selectors = section.querySelectorAll('.home-top-selector-section__selector');
      const products = section.querySelectorAll('.home-top-selector-section__product');
      const backgrounds = section.querySelectorAll('.home-top-selector-section__background');

      if (!selectors.length) return;

      function removeActiveStates() {
        selectors.forEach((selector) => {
          selector.classList.remove('home-top-selector-section__selector-active');
        });

        products.forEach((product) => {
          product.classList.remove('home-top-selector-section__product-active');
        });

        backgrounds.forEach((background) => {
          background.classList.remove('home-top-selector-section__background-active');

          const video = background.querySelector('video');
          if (video) {
            video.pause();
          }
        });
      }

      function activateSelector(index) {
        removeActiveStates();

        const activeSelector = section.querySelector(
          '.home-top-selector-section__selector[data-index="' + index + '"]'
        );
        const activeProduct = section.querySelector(
          '.home-top-selector-section__product[data-index="' + index + '"]'
        );
        const activeBackground = section.querySelector(
          '.home-top-selector-section__background[data-index="' + index + '"]'
        );

        if (activeSelector) {
          activeSelector.classList.add('home-top-selector-section__selector-active');
        }
        if (activeProduct) {
          activeProduct.classList.add('home-top-selector-section__product-active');
        }
        if (activeBackground) {
          activeBackground.classList.add('home-top-selector-section__background-active');

          const video = activeBackground.querySelector('video');
          if (video) {
            video.currentTime = 0;
            video.play().catch((e) => {
              console.log('Video autoplay failed:', e);
            });
          }
        }
      }

      // Klick-Events nur innerhalb dieser Section
      selectors.forEach((selector) => {
        selector.addEventListener('click', function () {
          const index = this.getAttribute('data-index');
          activateSelector(index);
        });
      });

      // Standard: erste Selector-Index dieser Section aktivieren
      const defaultIndex = selectors[0].getAttribute('data-index') || 0;
      activateSelector(defaultIndex);
    });
  }

  // Auf normal geladenen Seiten:
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initHomeTopSelectorSection(document);
    });
  } else {
    initHomeTopSelectorSection(document);
  }

  // Für Theme Editor: wenn eine Section neu geladen wird
  document.addEventListener('shopify:section:load', function (event) {
    initHomeTopSelectorSection(event.target);
  });
})();